import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --global-scale: 1.8; /* Adjust this value to scale all UI elements */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'SF Mono', Monaco, 'Consolas', 'Roboto Mono', monospace;
    background: #f8f9fa;
    color: #000;
    min-height: 100vh;
    line-height: 1.2;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, select {
    outline: none;
    font-family: inherit;
  }

  input:focus, select:focus {
    border-color: #000;
  }
`;

export const Container = styled.div`
  max-width: calc(600px * var(--global-scale));
  // max-width: calc(900px * var(--global-scale));
  margin: 0 auto;
  padding: calc(8px * var(--global-scale));
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: calc(4px * var(--global-scale));
  }
`;

export const Card = styled.div`
  background: #fff;
  border: calc(1px * var(--global-scale)) solid #ccc;
  padding: calc(12px * var(--global-scale));
  margin-bottom: calc(6px * var(--global-scale));

  @media (max-width: 768px) {
    padding: calc(8px * var(--global-scale));
    margin-bottom: calc(4px * var(--global-scale));
  }
`;

export const Button = styled.button`
  background: ${props => {
    if (props.variant === 'secondary') return '#666';
    if (props.variant === 'danger') return '#000';
    if (props.variant === 'success') return '#000';
    return '#000';
  }};
  color: white;
  padding: calc(6px * var(--global-scale)) calc(12px * var(--global-scale));
  font-size: calc(12px * var(--global-scale));
  font-weight: 600;
  width: 100%;
  margin-bottom: calc(2px * var(--global-scale));
  border: calc(2px * var(--global-scale)) solid #000;
  text-transform: uppercase;
  letter-spacing: calc(0.5px * var(--global-scale));
  
  &:hover {
    background: ${props => {
    if (props.variant === 'secondary') return '#000';
    if (props.variant === 'danger') return '#666';
    if (props.variant === 'success') return '#666';
    return '#666';
  }};
  }

  &:active {
    background: #333;
  }

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
    font-size: calc(10px * var(--global-scale));
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
  border: calc(2px * var(--global-scale)) solid #000;
  margin-bottom: calc(4px * var(--global-scale));
  font-size: calc(14px * var(--global-scale));
  background: white;
  font-family: inherit;

  &:focus {
    border-color: #000;
    background: #f0f0f0;
  }

  @media (max-width: 768px) {
    padding: calc(3px * var(--global-scale)) calc(6px * var(--global-scale));
    font-size: calc(12px * var(--global-scale));
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
  border: calc(2px * var(--global-scale)) solid #000;
  margin-bottom: calc(4px * var(--global-scale));
  font-size: calc(14px * var(--global-scale));
  background: white;
  cursor: pointer;
  font-family: inherit;

  &:focus {
    border-color: #000;
    background: #f0f0f0;
  }

  @media (max-width: 768px) {
    padding: calc(3px * var(--global-scale)) calc(6px * var(--global-scale));
    font-size: calc(12px * var(--global-scale));
  }
`;

export const Title = styled.h1`
  text-align: center;
  margin-bottom: calc(12px * var(--global-scale));
  font-size: calc(16px * var(--global-scale));
  color: #000;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: calc(1px * var(--global-scale));

  @media (max-width: 768px) {
    font-size: calc(14px * var(--global-scale));
    margin-bottom: calc(8px * var(--global-scale));
  }
`;

export const Subtitle = styled.h2`
  text-align: center;
  margin-bottom: calc(4px * var(--global-scale));
  font-size: calc(14px * var(--global-scale));
  color: #000;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: calc(12px * var(--global-scale));
    margin-bottom: calc(2px * var(--global-scale));
  }
`;

export const ScoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(70px * var(--global-scale)), 1fr));
  gap: calc(4px * var(--global-scale));
  margin-bottom: calc(8px * var(--global-scale));
`;

export const ScoreCard = styled.div`
  background: #fff;
  border: calc(1px * var(--global-scale)) solid #ccc;
  padding: calc(8px * var(--global-scale)) calc(4px * var(--global-scale));
  text-align: center;

  h3 {
    font-size: calc(9px * var(--global-scale));
    color: #666;
    margin-bottom: calc(4px * var(--global-scale));
    text-transform: uppercase;
    letter-spacing: calc(0.5px * var(--global-scale));
    font-weight: 500;
  }

  .score {
    font-size: calc(28px * var(--global-scale));
    font-weight: 900;
    color: #000;
    line-height: 1;
    font-family: 'SF Mono', Monaco, 'Consolas', 'Roboto Mono', monospace;
    margin-bottom: calc(4px * var(--global-scale));
  }

  @media (max-width: 768px) {
    padding: calc(6px * var(--global-scale)) calc(2px * var(--global-scale));
    
    h3 {
      font-size: calc(8px * var(--global-scale));
    }
    
    .score {
      font-size: calc(24px * var(--global-scale));
    }
  }
`;

export const LanguageSelector = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: calc(8px * var(--global-scale));
  border: calc(2px * var(--global-scale)) solid #000;
  padding: calc(2px * var(--global-scale));
`;

export const LanguageButton = styled.button`
  background: ${props => props.active ? '#000' : '#fff'};
  color: ${props => props.active ? '#fff' : '#000'};
  border: calc(2px * var(--global-scale)) solid #000;
  padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
  font-weight: 600;
  margin: 0;
  font-size: calc(10px * var(--global-scale));
  text-transform: uppercase;
  letter-spacing: calc(0.5px * var(--global-scale));

  &:hover {
    background: ${props => props.active ? '#000' : '#f0f0f0'};
  }
`;

export const RoundList = styled.div`
  max-height: calc(300px * var(--global-scale));
  overflow-y: auto;
  margin-bottom: calc(4px * var(--global-scale));
  border: calc(2px * var(--global-scale)) solid #000;
  background: #fff;
`;

export const RoundItem = styled.div`
  background: #fff;
  color: #000;
  border-bottom: calc(1px * var(--global-scale)) solid #000;
  padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
  margin-bottom: 0;

  &:last-child {
    border-bottom: none;
  }

  .round-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: calc(2px * var(--global-scale));
    font-weight: 600;
    font-size: calc(12px * var(--global-scale));
  }

  .round-details {
    font-size: calc(10px * var(--global-scale));
    opacity: 0.8;
  }
`;

export const PlayerSelectionButton = styled.button`
  background: ${props => {
    if (props.disabled) return '#f5f5f5';
    if (props.selected) return '#000';
    return '#fff';
  }};
  color: ${props => {
    if (props.disabled) return '#999';
    if (props.selected) return '#fff';
    return '#000';
  }};
  border: calc(2px * var(--global-scale)) solid ${props => {
    if (props.disabled) return '#ddd';
    if (props.selected) return '#000';
    return '#cc0000';
  }};
  padding: calc(6px * var(--global-scale)) calc(12px * var(--global-scale));
  font-size: calc(12px * var(--global-scale));
  font-weight: 600;
  width: 100%;
  margin-bottom: calc(2px * var(--global-scale));
  text-transform: uppercase;
  letter-spacing: calc(0.5px * var(--global-scale));
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  
  &:hover {
    background: ${props => {
    if (props.disabled) return '#f5f5f5';
    if (props.selected) return '#333';
    return '#f0f0f0';
  }};
    border-color: ${props => {
    if (props.disabled) return '#ddd';
    return '#cc0000';
  }};
  }

  @media (max-width: 768px) {
    padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
    font-size: calc(11px * var(--global-scale));
  }
`;

export const ThreeStatePlayerButton = styled.button`
  background: ${props => {
    if (props.state === 'won') return '#4CAF50';
    if (props.state === 'lost') return '#dc3545';
    return '#fff';
  }};
  color: ${props => {
    if (props.state === 'won' || props.state === 'lost') return '#fff';
    return '#000';
  }};
  border: calc(2px * var(--global-scale)) solid ${props => {
    if (props.state === 'won') return '#4CAF50';
    if (props.state === 'lost') return '#dc3545';
    return '#cc0000';
  }};
  padding: calc(8px * var(--global-scale)) calc(12px * var(--global-scale));
  font-size: calc(12px * var(--global-scale));
  font-weight: 600;
  width: 100%;
  margin-bottom: calc(4px * var(--global-scale));
  text-transform: uppercase;
  letter-spacing: calc(0.5px * var(--global-scale));
  cursor: pointer;
  position: relative;
  
  &:hover {
    opacity: 0.8;
  }

  &::after {
    content: '${props => {
    if (props.state === 'won') return ' ✓';
    if (props.state === 'lost') return ' ✗';
    return '';
  }}';
    font-size: calc(14px * var(--global-scale));
    margin-left: calc(4px * var(--global-scale));
  }

  @media (max-width: 768px) {
    padding: calc(6px * var(--global-scale)) calc(8px * var(--global-scale));
    font-size: calc(11px * var(--global-scale));
  }
`;

export const TabButton = styled.button`
  background: ${props => props.active ? '#000' : '#fff'};
  color: ${props => props.active ? '#fff' : '#000'};
  border: calc(2px * var(--global-scale)) solid #000;
  border-bottom: ${props => props.active ? 'none' : `calc(2px * var(--global-scale)) solid #000`};
  padding: calc(4px * var(--global-scale)) calc(8px * var(--global-scale));
  font-weight: 600;
  margin: 0;
  margin-right: calc(2px * var(--global-scale));
  font-size: calc(10px * var(--global-scale));
  text-transform: uppercase;
  letter-spacing: calc(0.5px * var(--global-scale));
  cursor: pointer;

  &:hover {
    background: ${props => props.active ? '#000' : '#f0f0f0'};
  }
`;

export const RulesContent = styled.div`
  line-height: 1.4;
  font-size: calc(12px * var(--global-scale));
  max-height: calc(50vh * var(--global-scale));
  overflow-y: auto;
  padding: calc(8px * var(--global-scale)) 0;
  border: calc(2px * var(--global-scale)) solid #000;
  padding: calc(8px * var(--global-scale));
  background: #fff;

  h4 {
    margin: calc(8px * var(--global-scale)) 0 calc(4px * var(--global-scale)) 0;
    color: #000;
    font-size: calc(12px * var(--global-scale));
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: calc(0.5px * var(--global-scale));
  }

  p {
    margin-bottom: calc(4px * var(--global-scale));
    font-size: calc(11px * var(--global-scale));
  }

  li {
    margin-left: calc(16px * var(--global-scale));
    margin-bottom: calc(2px * var(--global-scale));
    font-size: calc(11px * var(--global-scale));
  }

  @media (max-width: 768px) {
    font-size: calc(11px * var(--global-scale));
    max-height: calc(40vh * var(--global-scale));
    padding: calc(6px * var(--global-scale));

    h4 {
      font-size: calc(11px * var(--global-scale));
    }

    p, li {
      font-size: calc(10px * var(--global-scale));
    }
  }
`;

export const MenuContainer = styled(Container)`
  position: relative;
  overflow: hidden;
  // padding-top: 140px;
  // padding-top: 10%;
  // padding-top: calc(7% * var(--global-scale));
  padding-top: calc(4% * var(--global-scale));

  @media (max-width: 768px) {
    padding-top: calc(20px * var(--global-scale));
  }
`;

export const FloatingSuits = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
  
  /* Animation control variables */
  --fall-rate-multiplier: 1.8;
  --rotation-rate-multiplier: 5.0;
  
  .suit {
    position: absolute;
    font-size: calc(120px * var(--global-scale));
    opacity: 0.5;
    font-family: serif;
  }
  
  /* Red suits (hearts and diamonds) */
  .suit[data-suit="heart"],
  .suit[data-suit="diamond"] {
    color: #cc0000ff;
  }
  
  /* Black suits (spades and clubs) */
  .suit[data-suit="spade"],
  .suit[data-suit="club"] {
    color: #000;
  }
  
  .suit:nth-child(1) {
    left: 5%;
    top: calc(-15% * var(--global-scale));
    animation: fall1 calc(6s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 0s;
  }
  
  .suit:nth-child(2) {
    left: 15%;
    top: calc(-20% * var(--global-scale));
    animation: fall2 calc(7s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 3s;
  }
  
  .suit:nth-child(3) {
    left: 25%;
    top: calc(-12% * var(--global-scale));
    animation: fall3 calc(5.5s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 2.5s;
  }
  
  .suit:nth-child(4) {
    left: 35%;
    top: calc(-18% * var(--global-scale));
    animation: fall4 calc(6.5s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 8.8s;
  }
  
  .suit:nth-child(5) {
    left: 45%;
    top: calc(-25% * var(--global-scale));
    animation: fall5 calc(5.8s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 1.8s;
  }
  
  .suit:nth-child(6) {
    left: 55%;
    top: calc(-14% * var(--global-scale));
    animation: fall6 calc(6.2s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 3.2s;
  }
  
  .suit:nth-child(7) {
    left: 65%;
    top: calc(-22% * var(--global-scale));
    animation: fall7 calc(7.2s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 7.5s;
  }
  
  .suit:nth-child(8) {
    left: 75%;
    top: calc(-16% * var(--global-scale));
    animation: fall8 calc(5.2s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 0.8s;
  }
  
  .suit:nth-child(9) {
    left: 85%;
    top: calc(-28% * var(--global-scale));
    animation: fall1 calc(6.8s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 4.1s;
  }
  
  .suit:nth-child(10) {
    left: 95%;
    top: calc(-19% * var(--global-scale));
    animation: fall2 calc(5.9s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 3.7s;
  }
  
  .suit:nth-child(11) {
    left: 8%;
    top: calc(-21% * var(--global-scale));
    animation: fall3 calc(6.3s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 4.5s;
  }
  
  .suit:nth-child(12) {
    left: 18%;
    top: calc(-13% * var(--global-scale));
    animation: fall4 calc(7.1s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 5.2s;
  }
  
  .suit:nth-child(13) {
    left: 28%;
    top: calc(-26% * var(--global-scale));
    animation: fall5 calc(5.4s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 3.9s;
  }
  
  .suit:nth-child(14) {
    left: 3%;
    top: calc(-17% * var(--global-scale));
    animation: fall6 calc(6.7s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 8.3s;
  }
  
  .suit:nth-child(15) {
    left: 48%;
    top: calc(-24% * var(--global-scale));
    animation: fall7 calc(5.7s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 6.2s;
  }
  
  .suit:nth-child(16) {
    left: 58%;
    top: calc(-15% * var(--global-scale));
    animation: fall8 calc(6.9s * var(--fall-rate-multiplier)) infinite linear;
    animation-delay: 4.8s;
  }
  
  @keyframes fall1 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(20px) translateY(140vh) rotate(calc(36deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall2 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(-15px) translateY(140vh) rotate(calc(-27deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall3 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(30px) translateY(140vh) rotate(calc(45deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall4 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(-25px) translateY(140vh) rotate(calc(-18deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall5 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(10px) translateY(140vh) rotate(calc(54deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall6 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(-35px) translateY(140vh) rotate(calc(-36deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall7 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(40px) translateY(140vh) rotate(calc(27deg * var(--rotation-rate-multiplier))); }
  }
  
  @keyframes fall8 {
    0% { transform: translateX(0px) translateY(0px) rotate(0deg); }
    100% { transform: translateX(-10px) translateY(140vh) rotate(calc(-45deg * var(--rotation-rate-multiplier))); }
  }
  
  @media (max-width: 768px) {
    .suit {
      font-size: calc(50px * var(--global-scale));
      opacity: 0.15;
    }
  }
`;
